import { FilterBarOpenButton } from "./FilterBarOpenButton";
import FilterBar from "./FilterBar";
import { VerticalFilterBarProps } from "../vertical-filter-bar/VerticalFilterBar";
import { useRef, useState } from "react";

/**
 * A button that opens modal window with the filters (including the modal itself)
 */
export const FilterBarButtonWithModal = (props: VerticalFilterBarProps) => {
    const buttonRef = useRef<HTMLButtonElement | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <FilterBarOpenButton ref={buttonRef} onClick={() => setIsModalOpen(true)} />

            <FilterBar
                {...props}
                isModalOpen={isModalOpen}
                inModal={true}
                onModalClose={() => {
                    setIsModalOpen(false);
                    // when closing filters modal, focus the button that opened it:
                    buttonRef.current?.focus();
                }}
            />
        </>
    );
};
